/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { sizes, ScrollArea } from '@smartsheet/lodestar-core';
import { useSelector } from 'react-redux';
import { allStepsSector } from '../../../../../../services/ducks/workflowRunDuck/workflowRunDuck';
import { getVerticalSpacingAroundRunSteps } from '../../../../../../utils/dimensions';
import { StepsHeader } from '../StepsHeader';

const stepsContainerStyle = css`
  display: flex;
  padding: ${sizes.medium}px 0;
  height: calc(100vh - ${getVerticalSpacingAroundRunSteps()}px);
`;

const scrollAreaStyle = css`
  width: 100%;
`;

export const Steps = () => {
  const steps = useSelector(allStepsSector);
  const stepEls = steps.map((step, i) => (
    <StepsHeader stepId={step.id} key={i} />
  ));
  return (
    <div css={stepsContainerStyle} data-pa11y-id="run-steps">
      <ScrollArea css={scrollAreaStyle} gutter="none" scrollbarStyle="slim">
        {stepEls}
      </ScrollArea>
    </div>
  );
};
